module.exports = __webpack_public_path__ + "img/logoEurocaja.cc57968b.png";